import React from "react";
import { connect } from "react-redux";
import { push } from "redux-little-router";
import { Icon } from "semantic-ui-react";
import mixpanel from "../../services/mixpanel";
import { applyPostCategoryFilter } from "../../actions";
import "./index.css";

function PostCategoryBadge(props) {
  const { category, caseType, actions } = props;
  return (
    <label className="category" onClick={applyCategoryFilter}>
      <Icon name="folder" circular className="casemasterscolor" />
      {category}
    </label>
  );

  function applyCategoryFilter() {
    const categoryId = Number.parseInt(caseType, 10);
    actions.applyPostCategoryFilter(categoryId);
    mixpanel.track("category", { "category name": props.category });
    actions.push(`/category/${category.toLowerCase().replace(/ /g, "-")}`);
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      applyPostCategoryFilter: categoryId => dispatch(applyPostCategoryFilter(categoryId)),
      push: path => dispatch(push(path)),
    },
  };
}

export default connect(null, mapDispatchToProps)(PostCategoryBadge);



// WEBPACK FOOTER //
// ./src/components/PostCategoryBadge/index.js